// removed by extract-text-webpack-plugin
module.exports = {"linchen-shape":"linchen-shape","flash":"flash"};


//////////////////
// WEBPACK FOOTER
// ./src/pubBiz/FrameWork/Shape/index.less
// module id = 691
// module chunks = 418